import * as types from "./types";

const mutations = {
    [types.LOADING_JOURNALENTRYLINE](state, value) {
        state.loading = value;
    },
    [types.GET_JOURNALENTRYLINE_LIST](state, journalentryline) {
        state.journalentryline = journalentryline;
    },
    [types.GET_JOURNALENTRYLINE_ID](state, id) {
        state.id = id;
    },
    [types.REMOVE_JOURNALENTRYLINE](state, id) {        
        state.journalentryline = state.journalentryline.filter((x) => x.id !== id);        
    },
    [types.ADD_JOURNALENTRYLINE](state, journalentryline) {        
        state.journalentryline.unshift(journalentryline);
    },
    [types.UPDATE_JOURNALENTRYLINE](state, journalentryline) {        
        const journalentrylineIndex = state.journalentryline.findIndex((x) => x.id === journalentryline.id);
        state.journalentryline[journalentrylineIndex] = journalentryline;        
    }
};

export default mutations;